<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">月度指标</span>
    </div>
    <div class="main">
      <div class="itemWarp">
        <div class="mainCont">
          <div class="mainTitle">月度总进水量(m³)：</div>
          <span class="mainVal">{{ data.totalMonthlyInflow }}</span>
        </div>
        <div class="mainCont">
          <div class="mainTitle">月度总耗水量(m³)：</div>
          <span class="mainVal">{{ data.totalMonthlyWaterConsumption }}</span>
        </div>
        <div class="mainCont">
          <div class="mainTitle">月度总出水量(m³)：</div>
          <span class="mainVal">{{ data.totalMonthlyWaterOutput }}</span>
        </div>
        <div class="mainCont">
          <div class="mainTitle">月度总耗电量(度)：</div>
          <span class="mainVal">{{ data.totalMonthlyElectricityConsumption }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
export default {
  // mixins: [chartResize],
  name: 'Monthlyindicators',
  components: {},
  data () {
    return {
      queryUrl: '/pipe-network/total_monthly_targeteds/page',
      data: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      const data = { isType: false }
      this.$http.get(this.queryUrl, { params: data }).then(({ data }) => {
        this.data = data.list[0]
        console.log(JSON.stringify(this.data))
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 163px;
  width: 540px;
  background: url(~@/assets/myImg/h_9_ydzb_box.png) no-repeat;
  background-size: cover;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .main {
    position: absolute;
    top: 0;
    // float: left;
    height: 220px;
    width: 100%;

    .itemWarp {
      padding: 14px 20px 10px 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .mainCont {
        margin-top: 16px;
        height: 50px;
        width: 242px;
        padding: 6px 14px;
        padding-right: 0px;
        background: url(~@/assets/myImg/1/h_9_ydzb_zb_box.png) no-repeat;
        background-size: contain;
        overflow: visible;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .mainTitle {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 14px;
          color: #15a9f1;
          font-weight: 600;
        }

        .mainVal {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 22px;
          color: #00ebee;
          text-align: right;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
